import axios from "./AxiosWrapper";
import config from "../config";

const apiURL = config("API_URL");
const getTrendingEvents = async locale => {
  const response = await axios.get(`${apiURL}/trending/`, {});
  return response.data;
};

export default { getTrendingEvents };
